angular.module('dnecom')
    .filter('removeEmpty', function () {
        return function (items, key) {
            var filtered = [];

            _.forEach(items, function (item) {
                if (_.isObject(item)) {
                    if (item[key] && item[key].length > 0) {
                        filtered.push(item);
                    }
                } else if (key.length > 0) {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    });
